import * as React from 'react'
import { Button, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    IconButton, 
    Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { styled } from '@mui/material/styles'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

export const ChangePasswordSucces = ({open, onClose,}) =>{


    return(
        <React.Fragment>
        <BootstrapDialog open={open} onClose={onClose}>
        <DialogTitle color='secondary' sx={{ m: 0, padding: 2, mr: '3rem'}} onClose={onClose}>
                You have succesfully Changed Your Password
        </DialogTitle>
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        <DialogContent dividers>
            <Typography variant='body1'gutterBottom>
              You may close this alert.
            </Typography>
        </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={onClose} color="secondary">
              Close
            </Button>
          </DialogActions>
        </BootstrapDialog>
        </React.Fragment>

    )



}